<template>
    <div>
        <v-breadcrumbs class="breadcrumbs pr-4" :class="[$vuetify.breakpoint.width < 691 ? 'd-sm-none d-md-flex' : 'font12']" :items="breadcrumbs">
            <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
            </template>
        </v-breadcrumbs>
        <span
            v-if="breadcrumbs.length"
            :class="[$vuetify.breakpoint.width < 524 ? 'd-none d-sm-flex' : $vuetify.breakpoint.width > 690 ? 'd-sm-none' : '', 'breadcrumbs font12 pl-0 pr-2']"
        >
            {{ breadcrumbs[0].text }}
        </span>
    </div>
</template>
<style scoped></style>
<script>
    export default {
        name: 'app-menuBreadcrumbs',
        components: {},
        data() {
            return {};
        },

        created() {
            console.log('Component %s was created.', this.$options.name);
        },

        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },

        methods: {},

        computed: {
            breadcrumbs: {
                get() {
                    return this.$store.getters['MenuModule/getBreadcrumbs'];
                },
            },
        },
    };
</script>
